import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable()
export class SharedService extends BaseService {
    goToSiliCloud() : Observable<any> {
        return this.get('api/account/redirectToSiliCloud')
            .catch((error: any) => Observable.throw(error))
            .map((response: any) => {
                return response;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts